//messages.js
export default {
    payment_term_id: "Payment Term ID",
    payment_term: "Payment Term",
    term_days: "Term Days",
    description: "Description",
    edit_payment_term: "Edit Payment Term",
    add_payment_term: "Add Payment Term",
    delete_payment_term: "Delete Payment Term",
    payment_terms: "Payment Terms",
    delete_payment_term_confirm: "This action is not reversible!",
};
